import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { RecipientRequestVerifyStatusType } from '@/types/vendorVaultTypes';

export const getRecipientRequestVerificationStatusApi = (
  token: string
): Promise<ApiResponseType<RecipientRequestVerifyStatusType>> =>
  apiService.GET(`/recipient-requests/${token}/verify/status/`);
